let e;
function i() {
  return typeof document > "u" ? !1 : (e === void 0 && ("matchMedia" in window ? e = window.matchMedia("(pointer:coarse)").matches : e = !1), e);
}
let n;
function t() {
  return typeof document > "u" ? 1 : (n === void 0 && (n = "chrome" in window ? window.devicePixelRatio : 1), n);
}
export {
  i as ensureMaybeTouch,
  t as ensureWheelScale
};
